import Parse from "parse";

export async function getAllFolders() {
  var foldersBrique = await Parse.Cloud.run("getAllFolders", {});
  var monObject = JSON.parse(foldersBrique);
  return monObject;
}
